import { ITrackerContext } from 'com/didichuxing/tracker/context/ITrackerContext';
import { ITracker } from 'com/didichuxing/tracker/ITracker';
import { ITrackedEvent } from 'com/didichuxing/tracker/event/ITrackedEvent';
import { IObjectMap } from 'com/didichuxing/IObjectMap';
import { ITrackedEventArgs } from 'com/didichuxing/tracker/plugin/IReportingStrategyPlugin';
import AReportingStrategyPlugin from 'com/didichuxing/tracker/plugin/AReportingStrategyPlugin';
import OMGH5SafeTypingEvent from 'com/didichuxing/tracker/h5/plugins/events/OMGH5SafeTypingEvent';
import PluginUtils from 'com/didichuxing/tracker/plugin/utils/PluginUtils';

interface ISafeTyping {
    text: string; // 最终输入框的内容
    tl: number; // 从开始输入到输入结束的时间长度（ms）
    dl: number; // 输入框内容的删除次数
    count: number; // 输入框最终的字符个数
}

const FORM_ELEMENT_MAP: IObjectMap<string> = {
    input: 'input'
};
export default abstract class AOMGSafeTypingPlugin extends AReportingStrategyPlugin {
    private currentFormElement: HTMLElement | undefined;
    private currentDate: number = 0;
    private safeTyping: ISafeTyping = {
        text: '',
        tl: 0,
        dl: 0,
        count: 0
    };

    /**
     * @constructor
     */
    constructor(tracker: ITracker) {
        super(tracker);
        this.delegateInputChange = this.delegateInputChange.bind(this);
        this.reportSafeTyping = this.reportSafeTyping.bind(this);
    }

    /**
     * @override
     * @inheritDoc
     * @returns {string}
     */
    public getName(): string {
        return PluginUtils.PLUGIN_NAME_SAFETYPING;
    }

    /**
     * @override
     * @inheritDoc
     */
    public execute(): void {
        document.body.addEventListener('input', this.delegateInputChange);
        document.body.addEventListener('change', this.reportSafeTyping);
    }

    /**
     * @override
     * @inheritDoc
     */
    public exit(): void {
        this.currentFormElement = undefined;
        document.body.removeEventListener('input', this.delegateInputChange);
        document.body.removeEventListener('change', this.reportSafeTyping);
    }

    /**
     * 委托input change事件
     * @param {Event} event
     */
    private delegateInputChange(event: Event): void {
        const target: HTMLInputElement = event.target as HTMLInputElement;
        // 是否在监控类型中
        if ((target.tagName && FORM_ELEMENT_MAP[target.tagName.toLowerCase()]) ||
            (target.nodeName && FORM_ELEMENT_MAP[target.nodeName.toLowerCase()])) {
            if ( (!target.getAttribute('type')) || target.getAttribute('type') === 'text') {
                // 是否是同节点 如果是 说明并非新节点 进行运算
                if (this.currentFormElement === target) {
                    // @ts-ignore
                    if (event.inputType && event.inputType === 'deleteContentBackward') {
                        this.safeTyping.dl++;
                    } else if (target.value && this.safeTyping.text.length > target.value.length) {
                        this.safeTyping.dl++;
                    }
                    this.safeTyping.text = target.value || '';
                    this.currentFormElement = target;
                } else {
                    this.safeTyping = {
                        text: target.value || '',
                        tl: 0,
                        dl: 0,
                        count: 0
                    };
                    this.currentDate = new Date().getTime();
                    this.currentFormElement = target;
                }
            }
        }
    }

    /**
     * 发送数据
     * @param event
     */
    private reportSafeTyping(event: Event): void {
        const target: HTMLInputElement = event.target as HTMLInputElement;
        // 是否在监控类型中 如果在  就去上包
        if ((target.tagName && FORM_ELEMENT_MAP[target.tagName.toLowerCase()]) ||
            (target.nodeName && FORM_ELEMENT_MAP[target.nodeName.toLowerCase()])) {
            if ( (!target.getAttribute('type')) || target.getAttribute('type') === 'text' ) {
                this.safeTyping.text = target.value || '';
                this.safeTyping.tl = new Date().getTime() - this.currentDate;
                this.safeTyping.count = this.safeTyping.text.length;
                this.report({
                    eventId: PluginUtils.EVENT_ID_SAFETYPING,
                    attrs: this.safeTyping
                });
            }
        }
        this.currentFormElement = undefined;
    }

    /**
     * @override
     * @inheritDoc
     * @param {ITrackedEventArgs} eventArgs
     * @returns {ITrackedEvent}
     */
    protected generateEvent(eventArgs: ITrackedEventArgs): ITrackedEvent {
        return new OMGH5SafeTypingEvent(eventArgs.attrs, this.getContext());
    }
}
